"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortDirectionToJSON = exports.SortDirectionFromJSONTyped = exports.SortDirectionFromJSON = exports.SortDirection = void 0;
/**
 *
 * @export
 */
exports.SortDirection = {
    Asc: 'ASC',
    Desc: 'DESC'
};
function SortDirectionFromJSON(json) {
    return SortDirectionFromJSONTyped(json, false);
}
exports.SortDirectionFromJSON = SortDirectionFromJSON;
function SortDirectionFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.SortDirectionFromJSONTyped = SortDirectionFromJSONTyped;
function SortDirectionToJSON(value) {
    return value;
}
exports.SortDirectionToJSON = SortDirectionToJSON;
